import { render, staticRenderFns } from "./GraficaVehiculos.vue?vue&type=template&id=6d10ea9a"
import script from "./GraficaVehiculos.vue?vue&type=script&lang=js"
export * from "./GraficaVehiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports